"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundCheckScreeningResult = void 0;
exports.instanceOfBackgroundCheckScreeningResult = instanceOfBackgroundCheckScreeningResult;
exports.BackgroundCheckScreeningResultFromJSON = BackgroundCheckScreeningResultFromJSON;
exports.BackgroundCheckScreeningResultFromJSONTyped = BackgroundCheckScreeningResultFromJSONTyped;
exports.BackgroundCheckScreeningResultToJSON = BackgroundCheckScreeningResultToJSON;
exports.BackgroundCheckScreeningResultToJSONTyped = BackgroundCheckScreeningResultToJSONTyped;
/**
 *
 * @export
 */
exports.BackgroundCheckScreeningResult = {
    Clear: 'CLEAR',
    NeedsReview: 'NEEDS_REVIEW'
};
function instanceOfBackgroundCheckScreeningResult(value) {
    for (const key in exports.BackgroundCheckScreeningResult) {
        if (Object.prototype.hasOwnProperty.call(exports.BackgroundCheckScreeningResult, key)) {
            if (exports.BackgroundCheckScreeningResult[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BackgroundCheckScreeningResultFromJSON(json) {
    return BackgroundCheckScreeningResultFromJSONTyped(json, false);
}
function BackgroundCheckScreeningResultFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BackgroundCheckScreeningResultToJSON(value) {
    return value;
}
function BackgroundCheckScreeningResultToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=BackgroundCheckScreeningResult.js.map